import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight} from '@fortawesome/free-solid-svg-icons';


const FeelingCard = (props) => {
    return(
        <>
         
         <div className="card-container">
            <img src={props.img} alt="cruise feeling"></img>
            <h3 >{props.heading}</h3>
            {/* <p>{props.content}</p> */}
            <button className="explore-button">Explore<FontAwesomeIcon icon={ faArrowRight}  className="explore-arroy" /></button>

         </div>


        </>
    );
}

export default FeelingCard ;